import { render } from "./TheDrawingDialog.vue?vue&type=template&id=3106184f&scoped=true&ts=true"
import script from "./TheDrawingDialog.vue?vue&type=script&lang=ts"
export * from "./TheDrawingDialog.vue?vue&type=script&lang=ts"

import "./TheDrawingDialog.vue?vue&type=style&index=0&id=3106184f&scoped=true&lang=scss"

import exportComponent from "/data/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3106184f"]])

export default __exports__